<template>
    <type-wrapper class="type-I" regular :bgImage="currentShowData.image" :bgColor="currentShowData.bg_color">
        <!-- 多产品选择器 -->
        <type-grid row="11" margin v-if="productList.length > 1" style="margin-bottom: 15px;">
            <div class="product-selector">
                <div class="selector-nav">
                    <my-icon 
                        icon="chevron-left" 
                        size="20px" 
                        color="#FFFFFF" 
                        @click="prevProduct"
                        :style="{ opacity: currentIndex > 0 ? 1 : 0.3 }"
                    ></my-icon>
                    <div class="product-tabs">
                        <div 
                            v-for="(product, index) in productList" 
                            :key="getProductKey(product, index)"
                            class="product-tab"
                            :class="getProductTabClass(index)"
                            @click="selectProduct(index)"
                        >
                            <div class="tab-image">
                                <type-image mode="widthFix" :src="getProductPhoto(product)"></type-image>
                            </div>
                            <div class="tab-name">{{ getProductName(product) }}</div>
                        </div>
                    </div>
                    <my-icon 
                        icon="chevron-right" 
                        size="20px" 
                        color="#FFFFFF" 
                        @click="nextProduct"
                        :style="{ opacity: currentIndex < productList.length - 1 ? 1 : 0.3 }"
                    ></my-icon>
                </div>
            </div>
        </type-grid>

        <!-- 主要产品显示区域 -->
        <type-grid row="13" margin v-if="finalPrice > 0">
            <type-image mode="widthFix" :src="getCurrentLogo()"></type-image>
        </type-grid>
        <type-grid row="23" margin v-if="finalPrice > 0">
            <type-text type="title" size="3" align="left">{{ getCurrentName() }}</type-text>
            <type-text type="content" size="3" v-if="isProduct && finalPrice > 0">Price: {{ priceHandler(price, currency) }}</type-text>
        </type-grid>
        <type-grid row="11" v-if="getCurrentTitle()" style="margin-top: 10px;">
            <type-text type="title" size="3">{{ getCurrentTitle() }}</type-text>
        </type-grid>
        <type-grid row="11" v-if="getCurrentContent()" style="margin-bottom: 40px;">
            <type-text type="content" size="6" align="center">{{ getCurrentContent() }}</type-text>
        </type-grid>

        <!-- Form inputs with native event handling -->
        <type-grid row="13" margin>
            <type-input 
                ref="nameInput"
                :whitebackdrop="whitebackdrop" 
                v-model="name" 
                placeholder="Name"
                @focus="currentFocusedField = 'name'"
            ></type-input>
        </type-grid>
        
        <type-grid row="13" margin>
            <type-input 
                ref="emailInput"
                :whitebackdrop="whitebackdrop" 
                v-model="email" 
                placeholder="Email"
                type="email"
                @focus="currentFocusedField = 'email'"
            ></type-input>
        </type-grid>
        
        <type-grid row="13" margin>
            <type-input 
                ref="mobileInput"
                :whitebackdrop="whitebackdrop" 
                v-model="mobile"  
                :maxlength="mobileMaxlength" 
                prefix 
                placeholder="Phone"
                type="tel"
                @focus="currentFocusedField = 'mobile'"
            >
                <div slot="prefix" @click="changePre">{{ mobilePre }}</div>
            </type-input>
        </type-grid>
        
        <type-grid row="13" margin v-if="!shouldHideAddress">
            <type-input 
                ref="countryInput"
                :whitebackdrop="whitebackdrop" 
                v-model="country" 
                placeholder="Country"
                @focus="currentFocusedField = 'country'"
            ></type-input>
        </type-grid>
        
        <type-grid row="13" margin v-if="!shouldHideAddress">
            <type-input 
                ref="provinceInput"
                :whitebackdrop="whitebackdrop" 
                v-model="province" 
                placeholder="Province"
                @focus="currentFocusedField = 'province'"
            ></type-input>
        </type-grid>
        
        <type-grid row="13" margin v-if="!shouldHideAddress">
            <type-input 
                ref="cityInput"
                :whitebackdrop="whitebackdrop" 
                v-model="city" 
                placeholder="City"
                @focus="currentFocusedField = 'city'"
            ></type-input>
        </type-grid>
        
        <type-grid row="23" margin v-if="!shouldHideAddress">
            <type-input 
                ref="addressInput"
                :whitebackdrop="whitebackdrop" 
                v-model="address" 
                placeholder="Address"
                @focus="currentFocusedField = 'address'"
            ></type-input>
        </type-grid>
        
        <type-grid row="13" margin v-if="!shouldHideAddress">
            <type-input 
                ref="zipCodeInput"
                :whitebackdrop="whitebackdrop" 
                v-model="zipCode" 
                placeholder="Postcode"
                @focus="currentFocusedField = 'zipCode'"
            ></type-input>
        </type-grid>
        
        
        <type-grid row="13" margin v-if="finalPrice > 0">
            <type-input 
                ref="codeInput"
                :whitebackdrop="whitebackdrop" 
                v-model="code" 
                placeholder="Coupon"
                @focus="currentFocusedField = 'code'"
            ></type-input>
        </type-grid>
        
        <type-grid row="13" margin v-if="finalPrice > 0">
            <type-input 
                ref="quantityInput"
                :whitebackdrop="whitebackdrop" 
                v-model="quantity" 
                prefix 
                suffix 
                placeholder="Number"
                type="number"
                @focus="currentFocusedField = 'quantity'"
            >
                <my-icon icon="minus" size="20px" color="#FFFFFF" slot="prefix" @click="changeNum(0)"></my-icon>
                <my-icon icon="plus" size="20px" color="#FFFFFF" slot="suffix" @click="changeNum(1)"></my-icon>
            </type-input>
        </type-grid>

        <!-- <type-grid row="13" margin>
            <toggle-register-or-login v-model="visible" :whitebackdrop="whitebackdrop"></toggle-register-or-login>
        </type-grid> -->
        
        <type-grid row="11" margin>
            <type-textarea 
                ref="notesInput"
                :whitebackdrop="whitebackdrop" 
                v-model="notes" 
                placeholder="Message"
                @focus="currentFocusedField = 'notes'"
            ></type-textarea>
        </type-grid>

        <!-- File Upload Section -->
        <type-grid row="11" margin>
            <div class="file-upload-container">
                <input 
                    ref="fileInput"
                    type="file" 
                    accept=".pdf,.doc,.docx,.txt,.jpg,.jpeg,.png,.zip,.mp3,.m4a,.mp4"
                    @change="handleFileSelect"
                    style="display: none;"
                />
                <type-button 
                    :whitebackdrop="whitebackdrop" 
                    border 
                    :class="getButtonClass()"
                    @click="triggerFileSelect"
                >
                    <my-icon icon="upload" size="16px" color="#FFFFFF" style="margin-right: 8px;"></my-icon>
                    {{ selectedFile ? 'Change File' : 'Upload Document' }}
                </type-button>
            </div>
        </type-grid>

        <!-- Selected File Display -->
        <type-grid row="11" margin v-if="selectedFile">
            <div class="selected-file-display">
                <type-button 
                    :whitebackdrop="whitebackdrop" 
                    border 
                    :class="getButtonClass() + ' file-display-button'"
                    @click="removeFile"
                >
                    <my-icon icon="file" size="16px" color="#FFFFFF" style="margin-right: 8px;"></my-icon>
                    <span class="file-name">{{ selectedFile.name }}</span>
                    <my-icon icon="x" size="16px" color="#FFFFFF" style="margin-left: 8px;"></my-icon>
                </type-button>
            </div>
        </type-grid>

        <!-- Order Buttons -->
        <!-- Regular Stripe Order Button (hidden when price is 0) -->
        <type-grid row="11" margin v-if="finalPrice > 0">
            <type-button 
                :whitebackdrop="whitebackdrop" 
                border 
                :class="getButtonClass()"
                @click="placeOrder"
            >
                Order {{ priceHandler(finalPrice * Number(quantity), currency) }}
            </type-button>
        </type-grid>

        <!-- E-Transfer Button (always visible, text changes based on price) -->
        <type-grid row="11" margin>
            <type-button 
                :whitebackdrop="whitebackdrop" 
                border 
                :class="getButtonClass()"
                @click="placeETransferOrder"
            >
                {{ finalPrice > 0 ? `Order via E-Transfer ${priceHandler(finalPrice * Number(quantity), currency)}` : 'Submit Information' }}
            </type-button>
        </type-grid>

        <!-- Find Order Button -->
        <type-grid row="11" margin>
            <type-button 
                :whitebackdrop="whitebackdrop" 
                border 
                :class="getButtonClass()"
                @click="findOrder"
            >
                Find Order
            </type-button>
        </type-grid>

    </type-wrapper>
</template>

<script>
    // 预购买框
    import mixin from '../mixin.js'
    import toggleRegisterOrLogin from './toggle-register-or-login.vue'
    export default {
        name: 'type-I',
        mixins: [ mixin ],
        data() {
            return {
                visible: false, // 是否显示登陆/注册/购买弹窗
                name: this.$userInfo.data.name || '',
                email: this.$userInfo.data.email || '',
                mobile: '',
                country: '',
                province: '',
                city: '',
                address: '',
                zipCode: '',
                code: '',
                quantity: '1',
                notes: '',
                mobilePre: '+1',
                mobileMaxlength: '10',
                currentIndex: 0, // 当前选中的产品索引
                currentFocusedField: null, // Add this missing property
                fieldOrder: [
                    'nameInput',
                    'emailInput', 
                    'mobileInput',
                    'countryInput',
                    'provinceInput',
                    'cityInput',
                    'addressInput',
                    'zipCodeInput',
                    'codeInput',
                    'quantityInput'
                ],
                selectedFile: null, // Store selected file
                isUploading: false // Track upload state
            }
        },
        mounted() {
            console.log('Form component mounted, setting up event listeners...');
            this.setupKeyboardNavigation();
        },

        beforeDestroy() {
            // Clean up event listeners
            this.removeKeyboardNavigation();
        },
        computed: {
            // 产品列表
            productList() {
                // 如果是多产品模式，返回产品数组
                if (Array.isArray(this.showData)) {
                    return this.showData;
                }
                // 如果是单产品模式，返回包含单个产品的数组
                return [this.showData];
            },
            // 当前显示的产品数据
            currentShowData() {
                return this.productList[this.currentIndex] || this.productList[0] || {};
            },
            price() {
                return this.isProduct ? Number(this.currentShowData._object_data.product.price) : 0;
            },
            currency() {
                return this.isProduct ? this.currentShowData._object_data.product.currency : 'CNY';
            },
            isProduct() {
                const data = this.currentShowData;
                return Boolean(data._object_data && data._object_data.object_id && data._object_data.product_id && data._object_data.product);
            },
            finalPrice() {
                return this.price;
            },
            shouldHideAddress() {
                const data = this.currentShowData;
                return data._object_data && 
                    data._object_data.product && 
                    data._object_data.product.subtype == 1;
            },
            fieldOrder() {
                const baseFields = [
                    'nameInput',
                    'emailInput', 
                    'mobileInput'
                ];
                
                const addressFields = [
                    'countryInput',
                    'provinceInput',
                    'cityInput',
                    'addressInput',
                    'zipCodeInput'
                ];
                
                const endFields = [];
    
                // Only add coupon and quantity fields if price > 0
                if (this.finalPrice > 0) {
                    endFields.push('codeInput', 'quantityInput');
                }
                
                return this.shouldHideAddress 
                    ? [...baseFields, ...endFields]
                    : [...baseFields, ...addressFields, ...endFields];
            }
        },
        methods: {
            // File handling methods
            triggerFileSelect() {
                this.$refs.fileInput.click();
            },

            handleFileSelect(event) {
                const file = event.target.files[0];
                if (file) {
                    // Validate file size (e.g., max 10MB)
                    const maxSize = 10 * 1024 * 1024; // 10MB
                    if (file.size > maxSize) {
                        this.$message('File size must be less than 10MB');
                        return;
                    }

                    // Validate file type
                    const allowedTypes = [
                        'application/pdf',
                        'application/msword',
                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                        'text/plain',
                        'image/jpeg',
                        'image/jpg',
                        'image/png',
                        'application/zip',
                        'audio/mpeg',
                        'audio/mp4',
                        'video/mp4'
                    ];

                    if (!allowedTypes.includes(file.type)) {
                                                // Check by file extension as fallback
                        const fileName = file.name.toLowerCase();
                        const allowedExtensions = ['.pdf', '.doc', '.docx', '.txt', '.jpg', '.jpeg', '.png', '.zip', '.mp3', '.m4a', '.mp4'];
                        const hasValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));
                        
                        if (!hasValidExtension) {
                            this.$message('File type not supported. Please select a valid document, image, audio, or video file.');
                            return;
                        }
                    }

                    this.selectedFile = file;
                    console.log('File selected:', file.name, 'Size:', file.size, 'Type:', file.type);
                }
            },

            removeFile() {
                this.selectedFile = null;
                this.$refs.fileInput.value = '';
            },

            // Create FormData for file upload
            createFormDataWithFile(baseData) {
                const formData = new FormData();
                
                // Add all the base order data
                Object.keys(baseData).forEach(key => {
                    if (baseData[key] !== null && baseData[key] !== undefined) {
                        formData.append(key, baseData[key]);
                    }
                });

                // Add file if selected
                if (this.selectedFile) {
                    formData.append('document', this.selectedFile);
                }

                return formData;
            },

            // 获取产品key
            getProductKey(product, index) {
                if (product._object_data && product._object_data.object_id) {
                    return product._object_data.object_id;
                }
                return 'product-' + index;
            },
            // 获取产品tab的class
            getProductTabClass(index) {
                const classes = ['product-tab'];
                if (index === this.currentIndex) {
                    classes.push('active');
                }
                if (this.whitebackdrop) {
                    classes.push('white-backdrop');
                }
                return classes;
            },
            // 获取产品图片
            getProductPhoto(product) {
                return  product._object_data.photo || product._photo || product.photo || '';
            },
            // 获取产品名称
            getProductName(product) {
                return product._name || product.name || '';
            },
            // 获取当前logo
            getCurrentLogo() {
                return this.currentShowData.logo || this.currentShowData._photo || '';
            },
            // 获取当前名称
            getCurrentName() {
                return this.currentShowData.name || this.currentShowData._name || '';
            },
            // 获取当前标题
            getCurrentTitle() {
                if (this.currentShowData.title) {
                    return this.currentShowData.title;
                }
                if (this.currentShowData._tuwen_data && this.currentShowData._tuwen_data.title) {
                    return this.currentShowData._tuwen_data.title;
                }
                return '';
            },
            // 获取当前内容
            getCurrentContent() {
                if (this.currentShowData.content) {
                    return this.currentShowData.content;
                }
                if (this.currentShowData._tuwen_data && this.currentShowData._tuwen_data.content) {
                    return this.currentShowData._tuwen_data.content;
                }
                return '';
            },
            // 选择产品
            selectProduct(index) {
                if (index >= 0 && index < this.productList.length) {
                    this.currentIndex = index;
                }
            },
            // 上一个产品
            prevProduct() {
                if (this.currentIndex > 0) {
                    this.currentIndex--;
                }
            },
            // 下一个产品
            nextProduct() {
                if (this.currentIndex < this.productList.length - 1) {
                    this.currentIndex++;
                }
            },
            setupKeyboardNavigation() {
                // Add event listener to the entire component
                this.keydownHandler = (e) => {
                    if (e.key === 'Enter' || e.keyCode === 13) {
                        console.log('Enter key detected');
                        
                        // Find which field is currently focused
                        const activeElement = document.activeElement;
                        if (activeElement && (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA')) {
                            e.preventDefault();
                            e.stopPropagation();
                            
                            // Find the current field ref
                            const currentFieldRef = this.findCurrentFieldRef(activeElement);
                            if (currentFieldRef) {
                                console.log('Current field found:', currentFieldRef);
                                this.focusNext(currentFieldRef);
                            }
                        }
                    }
                };

                // Add listener to the component root
                this.$el.addEventListener('keydown', this.keydownHandler, true);
                
                // Also add to document for better coverage
                document.addEventListener('keydown', this.keydownHandler, true);
            },

            /**
             * Remove keyboard navigation event listeners
             */
            removeKeyboardNavigation() {
                if (this.keydownHandler) {
                    this.$el.removeEventListener('keydown', this.keydownHandler, true);
                    document.removeEventListener('keydown', this.keydownHandler, true);
                }
            },

            /**
             * Find which field ref corresponds to the active element
             */
            findCurrentFieldRef(activeElement) {
                for (const refName of this.fieldOrder) {
                    const fieldRef = this.$refs[refName];
                    if (fieldRef && fieldRef.$el) {
                        // Check if the active element is inside this component
                        const inputs = fieldRef.$el.querySelectorAll('input, textarea');
                        for (const input of inputs) {
                            if (input === activeElement) {
                                return refName;
                            }
                        }
                    }
                }
                return null;
            },

            /**
             * Focus next field in sequence
             */
            focusNext(currentRef) {
                console.log('focusNext called with:', currentRef);
                
                const currentIndex = this.fieldOrder.indexOf(currentRef);
                console.log('Current field index:', currentIndex);
                
                if (currentIndex === -1) {
                    console.warn('Current field not found in field order');
                    return;
                }
                
                const nextIndex = currentIndex + 1;
                
                if (nextIndex < this.fieldOrder.length) {
                    const nextFieldRef = this.fieldOrder[nextIndex];
                    console.log('Next field:', nextFieldRef);
                    this.focusField(nextFieldRef);
                } else {
                    console.log('Last field reached, handling last field enter');
                    this.handleLastFieldEnter();
                }
            },

            /**
             * Focus a specific field with multiple strategies
             */
            focusField(refName) {
                console.log('Attempting to focus field:', refName);
                
                this.$nextTick(() => {
                    const fieldRef = this.$refs[refName];
                    console.log('Field ref found:', !!fieldRef);
                    
                    if (!fieldRef) {
                        console.warn('Field ref not found:', refName);
                        return;
                    }

                    let focused = false;

                    // Strategy 1: Find input/textarea in component and focus
                    if (fieldRef.$el) {
                        const input = fieldRef.$el.querySelector('input') || 
                                     fieldRef.$el.querySelector('textarea');
                        if (input) {
                            console.log('Found input element, focusing...');
                            input.focus();
                            this.scrollToField(input);
                            focused = true;
                        }
                    }

                    // Strategy 2: Try component's focus method
                    if (!focused && typeof fieldRef.focus === 'function') {
                        console.log('Using component focus method...');
                        fieldRef.focus();
                        focused = true;
                    }

                    // Strategy 3: Try focusing component root
                    if (!focused && fieldRef.$el && typeof fieldRef.$el.focus === 'function') {
                        console.log('Focusing component root element...');
                        fieldRef.$el.focus();
                        focused = true;
                    }

                    if (!focused) {
                        console.warn('Could not focus field:', refName);
                    }
                });
            },

            /**
             * Scroll to keep field visible
             */
            scrollToField(element) {
                if (!element) return;
                
                console.log('Scrolling to field...');
                
                setTimeout(() => {
                    const rect = element.getBoundingClientRect();
                    const viewportHeight = window.innerHeight;
                    const elementTop = rect.top;
                    const elementHeight = rect.height;
                    
                    // Check if element needs scrolling
                    if (elementTop < 100 || elementTop + elementHeight > viewportHeight - 100) {
                        element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center',
                            inline: 'nearest'
                        });
                    }
                }, 50);
            },

            /**
             * Handle last field enter
             */
            handleLastFieldEnter() {
                console.log('Handling last field enter');
                
                // Blur current field
                if (document.activeElement) {
                    document.activeElement.blur();
                }
                
                // Focus order button
                setTimeout(() => {
                    const orderButton = this.$el.querySelector('button') || 
                                      this.$el.querySelector('.type-button button') ||
                                      this.$el.querySelector('[role="button"]');
                    if (orderButton) {
                        orderButton.focus();
                        console.log('Focused order button');
                    } else {
                        console.log('Order button not found');
                    }
                }, 100);
            },

            /**
             * Enhanced change prefix with focus retention
             */
            changePre() {
                if (this.mobilePre === '+1') {
                    this.mobilePre = '+86';
                    this.mobileMaxlength = '11';
                } else {
                    this.mobilePre = '+1';
                    this.mobileMaxlength = '10';
                    if (this.mobile.length > 10) {
                        this.mobile = this.mobile.slice(0, 10);
                    }
                }
                
                // Keep focus on mobile input after prefix change
                setTimeout(() => {
                    this.focusField('mobileInput');
                }, 100);
            },

            /**
             * Enhanced change number with focus retention
             */
            changeNum(status) {
                if (isNaN(this.quantity)) {
                    this.$message('Please enter number >0');
                    return false;
                }
                const number = Number(this.quantity);
                if (status) {
                    this.quantity = String(number + 1);
                } else {
                    this.quantity = String(number > 1 ? (number - 1) : number);
                }
                
                // Keep focus on quantity input after number change
                setTimeout(() => {
                    this.focusField('quantityInput');
                }, 100);
            },

            findOrder() {
                this.$router.push({
                    path: '/find_orders'
                });
            },

            // 在 methods 中添加按钮样式方法
            getButtonClass() {
                return this.whitebackdrop ? 'button-dark-theme' : 'button-light-theme';
            },
            priceHandler(price = 0, currency = 'CNY') {
                const currencyList = [
                    { label: '人民币', value: 'CNY', symbol: '¥' },
                    { label: '美元',   value: 'USD', symbol: '$' },
                    { label: '加元',   value: 'CAD', symbol: '$' },
                    { label: '欧元',   value: 'EUR', symbol: '€' },
                ];
                const index = currencyList.findIndex(item => item.value == currency);
                const str = index > -1 ? currencyList[index].symbol : '$';
                // 单位是分
                const [ one, two ] = currency === 'CNY' ? String(price / 100).split('.').filter(Boolean) : String(price/100).split('.').filter(Boolean);
                return str + ' ' + one + '.' + (two || '').padEnd(2, '0');
            },
            async placeOrder() {
                // 如果没有绑定产品就不购买
                // Get HOSTNAME from config
                const success_url = this.$config.HOSTNAME;
                const cancel_url = this.$config.HOSTNAME;
                
                const { _object_data } = this.currentShowData;
                // 微信小程序端未引入支付js链接
                if (this.$config.QUERY['notPay']) {
                    return;
                }
                if (this.isProduct) {} else {
                    this.$message('未绑定产品，无须购买');
                    return;
                }
                
                const data = {
                    name: this.name,
                    email: this.email,
                    mobile: (this.mobilePre === '+1' ? '1' : '+86') + this.mobile,
                    country: this.shouldHideAddress ? 'NA' : this.country,
                    province: this.shouldHideAddress ? 'NA' : this.province,
                    city: this.shouldHideAddress ? 'NA' : this.city,
                    address: this.shouldHideAddress ? 'NA' : this.address,
                    zipCode: this.shouldHideAddress ? 'NA' : this.zipCode,
                    code: this.code,
                    quantity: this.quantity,
                    notes: this.notes
                };
                const result = this.$verify.verify(data);
                if (result.tip) {
                    this.$message(result.tip);
                    return;
                }

                const req = Object.create(null);
                const buyer_user_id = '2';
                const final_price = String(this.finalPrice);
                const address_json_string = {
                    country: data.country,
                    province: data.province,
                    city: data.city,
                    address: data.address,
                    name: data.name,
                    email: data.email,
                    mobile: data.mobile,
                    zipCode: data.zipCode
                };
                req.is_single_product = '1';
                req.product_id = _object_data.product_id;
                // Fix for empty product name
                const productName = _object_data.name || 
                        (this.getCurrentTitle() ? this.getCurrentTitle() : "Owy's Fun Play System");
                req.product_name = productName;
                req.product_description = _object_data.product.description;
                req.product_json_string = '';
                req.quantity = String(data.quantity || '1');
                if (data.code == 'DREAMER') {
                    req.final_price = String(Math.round(parseFloat(final_price) / 2));
                }else
                {
                    req.final_price = final_price;
                }
                req.currency = _object_data.product.currency;
                if (_object_data.product.type == 1){
                    req.origin = 'tian';
                }else{
                    req.origin = 'xito';
                }
                if (_object_data.product.subtype == 1){
                    req.address_hide = true;
                }else{
                    req.address_hide = false;
                }
                req.customer_email = data.email;
                req.receiver_name = data.name;
                req.coupon_id_used = '1';
                req.payment_channel = 'stripe';
                req.address_json_string = JSON.stringify(address_json_string);
                req.object_id = _object_data.object_id;
                req.seller_user_id = _object_data.owner_user_id;
                req.buyer_user_id = buyer_user_id;
                req.is_digital = '0';
                req.notes = data.notes;
                req.success_url = success_url;
                req.cancel_url = cancel_url;
                
                console.log('下单数据', JSON.parse(JSON.stringify(req)));

                let orderResult;
                
                // If file is selected, use FormData for multipart upload
                if (this.selectedFile) {
                    this.isUploading = true;
                    try {
                        const formData = this.createFormDataWithFile(req);
                        orderResult = await this.$http.order.addWithFile(formData);
                    } catch (error) {
                        this.$message('File upload failed: ' + error.message);
                        this.isUploading = false;
                        return;
                    }
                    this.isUploading = false;
                } else {
                    orderResult = await this.$http.order.add(req);
                }

                if (orderResult.status !== 'success') {
                    return;
                }
                console.log('订单数据', JSON.parse(JSON.stringify(orderResult.data)));

                let stripe;
                if (_object_data.product.type == 1) {
                    stripe = Stripe(this.$config.STRIPE_KEY_tian);
                } else {
                    stripe = Stripe(this.$config.STRIPE_KEY_xito);
                }
                const stripeResult = await stripe.redirectToCheckout({ sessionId: orderResult.data.stripe_session_id });
                console.log('支付结果', JSON.parse(JSON.stringify(stripeResult)));
                if (stripeResult.error && stripeResult.error.code) {
                    this.$message('下单失败');
                }
            },
            async placeETransferOrder() {
                // 如果没有绑定产品就不购买
                // Get HOSTNAME from config
                const success_url = this.$config.HOSTNAME;
                const cancel_url = this.$config.HOSTNAME;
                
                const { _object_data } = this.currentShowData;
                // 微信小程序端未引入支付js链接
                if (this.$config.QUERY['notPay']) {
                    return;
                }
                if (this.isProduct) {} else {
                    this.$message('未绑定产品，无须购买');
                    return;
                }
                
                const data = {
                    name: this.name,
                    email: this.email,
                    mobile: (this.mobilePre === '+1' ? '1' : '+86') + this.mobile,
                    country: this.shouldHideAddress ? 'NA' : this.country,
                    province: this.shouldHideAddress ? 'NA' : this.province,
                    city: this.shouldHideAddress ? 'NA' : this.city,
                    address: this.shouldHideAddress ? 'NA' : this.address,
                    zipCode: this.shouldHideAddress ? 'NA' : this.zipCode,
                    code: this.code,
                    quantity: this.quantity,
                    notes: this.notes
                };
                const result = this.$verify.verify(data);
                if (result.tip) {
                    this.$message(result.tip);
                    return;
                }

                const req = Object.create(null);
                const buyer_user_id = '2';
                const final_price = String(this.finalPrice);
                const address_json_string = {
                    country: data.country,
                    province: data.province,
                    city: data.city,
                    address: data.address,
                    name: data.name,
                    email: data.email,
                    mobile: data.mobile,
                    zipCode: data.zipCode
                };
                req.is_single_product = '1';
                req.product_id = _object_data.product_id;
                // Fix for empty product name
                const productName = _object_data.name || 
                        (this.getCurrentTitle() ? this.getCurrentTitle() : "Owy's Fun Play System");
                req.product_name = productName;
                req.product_description = _object_data.product.description;
                req.product_json_string = '';
                req.quantity = String(data.quantity || '1');
                if (data.code == 'DREAMER') {
                    req.final_price = String(Math.round(parseFloat(final_price) / 2));
                }else
                {
                    req.final_price = final_price;
                }
                req.currency = _object_data.product.currency;
                if (_object_data.product.type == 1){
                    req.origin = 'tian';
                }else{
                    req.origin = 'xito';
                }
                if (_object_data.product.subtype == 1){
                    req.address_hide = true;
                }else{
                    req.address_hide = false;
                }
                req.customer_email = data.email;
                req.receiver_name = data.name;
                req.coupon_id_used = '1';
                req.payment_channel = 'etransfer';
                req.address_json_string = JSON.stringify(address_json_string);
                req.object_id = _object_data.object_id;
                req.seller_user_id = _object_data.owner_user_id;
                req.buyer_user_id = buyer_user_id;
                req.is_digital = '0';
                req.notes = data.notes;
                req.success_url = success_url;
                req.cancel_url = cancel_url;
                
                console.log('下单数据', JSON.parse(JSON.stringify(req)));

                let orderResult;
                
                // If file is selected, use FormData for multipart upload
                if (this.selectedFile) {
                    this.isUploading = true;
                    try {
                        const formData = this.createFormDataWithFile(req);
                        orderResult = await this.$http.order.addWithFile(formData);
                    } catch (error) {
                        this.$message('File upload failed: ' + error.message);
                        this.isUploading = false;
                        return;
                    }
                    this.isUploading = false;
                } else {
                    orderResult = await this.$http.order.add(req);
                }

                if (orderResult.status !== 'success') {
                    return;
                }
                
                // For free products or e-transfer, redirect to find orders page
                this.$router.push({
                    path: '/find_orders',
                    query: {
                        email: data.email,
                        orderId: orderResult.data.order_unique_id,
                        autoSearch: 'true'
                    }
                });
            }
        },
        components: {
            'toggle-register-or-login': toggleRegisterOrLogin
        }
    }
</script>

<style scoped lang="less">
    .type-I{
        // Prevent zoom on iOS when focusing inputs
        input, textarea, select {
            font-size: 16px !important;
            transform: translateZ(0);
            -webkit-appearance: none;
        }
        
        // Smooth transitions for focus states
        .type-input {
            transition: all 0.3s ease;
            
            &:focus-within {
                transform: translateY(-2px);
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            }
        }
        
        // Ensure proper scroll behavior
        scroll-behavior: smooth;

        // File upload container styling
        .file-upload-container {
            width: 100%;
            
            input[type="file"] {
                display: none;
            }
        }

        // Selected file display styling
        .selected-file-display {
            width: 100%;
            
            .file-display-button {
                display: flex !important;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                text-align: left;
                
                .file-name {
                    flex: 1;
                    margin: 0 8px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-size: 14px;
                }
            }
        }

        // Loading state for file upload
        .uploading {
            opacity: 0.6;
            pointer-events: none;
        }
    }

    // 在 style 中添加按钮样式
    .button-light-theme {
        color: #ffffff !important;
        border-color: #ffffff !important;
    }

    .button-dark-theme {
        color: #ffffff !important;
        border-color: #ffffff !important;
    }

    .product-selector {
        width: 100%;
        padding: 15px 0;
        
        .selector-nav {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 15px;
            
            .product-tabs {
                display: flex;
                gap: 12px;
                overflow-x: auto;
                max-width: calc(100% - 100px);
                padding: 0 5px;
                
                &::-webkit-scrollbar {
                    display: none;
                }
                
                .product-tab {
                    flex-shrink: 0;
                    width: 120px;
                    text-align: center;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    opacity: 0.6;
                    transform: scale(0.9);
                    border-radius: 12px;
                    padding: 10px;
                    background: rgba(255, 255, 255, 0.1);
                    backdrop-filter: blur(10px);
                    border: 2px solid transparent;
                    
                    &.white-backdrop {
                        background: rgba(0, 0, 0, 0.05);
                        border-color: rgba(0, 0, 0, 0.1);
                    }
                    
                    &.active {
                        opacity: 1;
                        transform: scale(1);
                        background: rgba(255, 255, 255, 0.2);
                        border-color: rgba(255, 255, 255, 0.5);
                    }
                    
                    &.active.white-backdrop {
                        background: rgba(0, 0, 0, 0.1);
                        border-color: rgba(0, 0, 0, 0.3);
                    }
                    
                    .tab-image {
                        width: 80px;
                        height: 80px;
                        border-radius: 8px;
                        overflow: hidden;
                        margin: 0 auto 8px;
                        border: 1px solid rgba(255, 255, 255, 0.2);
                    }
                    
                    .white-backdrop .tab-image {
                        border-color: rgba(0, 0, 0, 0.1);
                    }

                    .tab-name {
                        font-size: 12px;
                        line-height: 1.3;
                        max-height: 32px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        font-weight: 500;
                        color: rgba(255, 255, 255, 0.8); // 默认浅色主题
                    }

                    &.white-backdrop .tab-name {
                        color: rgba(255, 255, 255, 0.8); // 深色主题
                    }

                    &.active .tab-name {
                        font-weight: bold;
                        color: #ffffff; // 激活状态浅色主题
                    }

                    &.active.white-backdrop .tab-name {
                        color: #ffffff; // 激活状态深色主题
                    }
                }
            }
        }
    }
    
    /* 响应式设计 */
    @media (max-width: 480px) {
        .product-selector {
            .selector-nav {
                gap: 10px;
                
                .product-tabs {
                    max-width: calc(100% - 80px);
                    gap: 8px;
                    
                    .product-tab {
                        width: 100px;
                        padding: 8px;
                        
                        .tab-image {
                            width: 60px;
                            height: 60px;
                        }
                        
                        .tab-name {
                            font-size: 11px;
                            max-height: 28px;
                        }
                    }
                }
            }
        }
    }
</style>